var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3466 29.6666H11.6533C5.10664 29.6666 2.30664 26.8666 2.30664 20.32V20.1466C2.30664 14.2266 4.63997 11.3733 9.86664 10.88C10.4 10.84 10.9066 11.24 10.96 11.7866C11.0133 12.3333 10.6133 12.8266 10.0533 12.88C5.86664 13.2666 4.30664 15.24 4.30664 20.16V20.3333C4.30664 25.76 6.22664 27.68 11.6533 27.68H20.3466C25.7733 27.68 27.6933 25.76 27.6933 20.3333V20.16C27.6933 15.2133 26.1066 13.24 21.84 12.88C21.2933 12.8266 20.88 12.3466 20.9333 11.8C20.9866 11.2533 21.4533 10.84 22.0133 10.8933C27.32 11.3466 29.6933 14.2133 29.6933 20.1733V20.3466C29.6933 26.8666 26.8933 29.6666 20.3466 29.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20.8401C15.4533 20.8401 15 20.3867 15 19.8401V2.66675C15 2.12008 15.4533 1.66675 16 1.66675C16.5467 1.66675 17 2.12008 17 2.66675V19.8401C17 20.4001 16.5467 20.8401 16 20.8401Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 22.3335C15.7471 22.3335 15.4938 22.2401 15.2938 22.0401L10.8271 17.5735C10.4404 17.1868 10.4404 16.5468 10.8271 16.1601C11.2138 15.7735 11.8538 15.7735 12.2404 16.1601L16.0004 19.9201L19.7604 16.1601C20.1471 15.7735 20.7871 15.7735 21.1738 16.1601C21.5604 16.5468 21.5604 17.1868 21.1738 17.5735L16.7071 22.0401C16.5071 22.2401 16.2538 22.3335 16.0004 22.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.9648d648956726f5729d861d60b87d9c.svg";
export { ForwardRef as ReactComponent };